import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { RescheduledBooking } = await import('@containers/Payment/RescheduledBooking');
    return {
        Component: RescheduledBooking,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
